/**
 * Whether the stored GST verdict prevents the vendor from ever reaching
 * 'compliant'. Mirrors `hasUnregisteredGst` in the server's
 * `resolveCompanyStatus`, where a confirmed `false` is treated identically to an
 * invalid ABN.
 *
 * Strictly `=== false`: null means never checked / ABN invalid / register
 * unreachable, and the server deliberately lets those through so an ABR outage
 * cannot demote vendors. A `!gstRegistered` shortcut would flag every
 * never-checked vendor as blocked.
 */
export function gstBlocksCompliance(gstRegistered: boolean | null | undefined): boolean {
  return gstRegistered === false;
}
